import React from "react";

/**
 * Image wrapper with sensible defaults for performance:
 *   - loading="lazy"      → defers off-screen images
 *   - decoding="async"    → won't block main thread
 *   - fetchPriority       → "high" for above-the-fold hero, "low" for cards
 *   - Optionally appends Pexels compression params if the src is a Pexels URL
 *     and no query string is already present
 *
 *   <Img src={url} alt="…" w={800} priority />     // hero
 *   <Img src={url} alt="…" w={600} />              // card
 */
export default function Img({
  src,
  alt = "",
  className = "",
  priority = false,
  w = 800,
  ...rest
}) {
  if (!src) return null;
  let finalSrc = src;
  // Pexels: scale + compress to ~half the size
  if (src.includes("images.pexels.com") && !src.includes("?")) {
    finalSrc = `${src}?auto=compress&cs=tinysrgb&w=${w}`;
  }
  return (
    <img
      src={finalSrc}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchpriority={priority ? "high" : "low"}
      className={className}
      {...rest}
    />
  );
}
